import React, { useState, useEffect } from 'react';
import { motion } from 'framer-motion';

const ComingSoon = () => {
  const [text, setText] = useState('');
  const fullText = "SYSTEM INITIALIZATION... ACCESS DENIED. PROTOCOL UPGRADE IN PROGRESS.";

  useEffect(() => {
    let i = 0;
    const interval = setInterval(() => {
      setText(fullText.slice(0, i));
      i++;
      if (i > fullText.length) clearInterval(interval);
    }, 50);
    return () => clearInterval(interval);
  }, []);

  return (
    <div className="fixed inset-0 z-[9999] bg-black text-cyan-500 font-mono overflow-hidden flex flex-col items-center justify-center">
      {/* Grid Background */}
      <div className="absolute inset-0 opacity-20 pointer-events-none" 
           style={{ 
             backgroundImage: 'linear-gradient(0deg, transparent 24%, rgba(6, 182, 212, .3) 25%, rgba(6, 182, 212, .3) 26%, transparent 27%, transparent 74%, rgba(6, 182, 212, .3) 75%, rgba(6, 182, 212, .3) 76%, transparent 77%, transparent), linear-gradient(90deg, transparent 24%, rgba(6, 182, 212, .3) 25%, rgba(6, 182, 212, .3) 26%, transparent 27%, transparent 74%, rgba(6, 182, 212, .3) 75%, rgba(6, 182, 212, .3) 76%, transparent 77%, transparent)',
             backgroundSize: '50px 50px'
           }} 
      />
      
      {/* Scanline */}
      <div className="absolute inset-0 pointer-events-none bg-gradient-to-b from-transparent via-cyan-900/5 to-transparent" style={{ backgroundSize: '100% 3px' }} />

      <div className="relative z-10 border-2 border-cyan-500 p-8 max-w-3xl w-[90%] bg-black/90 backdrop-blur-md shadow-[0_0_30px_rgba(6,182,212,0.3)]">
        {/* HUD Corners */}
        <div className="absolute -top-1 -left-1 w-6 h-6 border-t-4 border-l-4 border-red-600" />
        <div className="absolute -top-1 -right-1 w-6 h-6 border-t-4 border-r-4 border-red-600" />
        <div className="absolute -bottom-1 -left-1 w-6 h-6 border-b-4 border-l-4 border-red-600" />
        <div className="absolute -bottom-1 -right-1 w-6 h-6 border-b-4 border-r-4 border-red-600" />

        <div className="flex flex-col items-center gap-8 py-8">
          <motion.div 
            initial={{ opacity: 0, scale: 0.9 }}
            animate={{ opacity: 1, scale: 1 }}
            className="text-red-500 text-xl md:text-2xl tracking-[0.5em] font-bold border-b border-red-500 pb-2 text-center"
          >
            RESTRICTED AREA
          </motion.div>

          <h1 className="text-5xl md:text-8xl font-black text-transparent bg-clip-text bg-gradient-to-b from-cyan-300 to-cyan-700 tracking-tighter filter drop-shadow-[0_0_10px_rgba(6,182,212,0.8)] text-center">
            COMING SOON
          </h1>

          <div className="h-20 flex items-center justify-center">
            <p className="text-cyan-400 text-lg md:text-xl text-center font-bold">
              {text}<span className="animate-pulse">_</span>
            </p>
          </div>

          <div className="w-full bg-gray-900 h-1 border border-cyan-900 mt-4 relative overflow-hidden">
            <motion.div 
              className="absolute top-0 left-0 h-full bg-red-600"
              initial={{ x: "-100%" }}
              animate={{ x: "100%" }}
              transition={{ duration: 2, repeat: Infinity, ease: "linear" }}
              style={{ width: "50%" }}
            />
          </div>
          
          <div className="flex justify-between w-full text-xs text-cyan-700 mt-2 uppercase font-semibold tracking-wider">
            <span>Sys.Ver. 3.0.0</span>
            <span className="hidden md:inline">Secure Connection: ESTABLISHED</span>
            <span>Plume Protocol</span>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ComingSoon;
